

import React, { useEffect, useState } from "react";

import { Link as RouterLink, useSearchParams, useParams, useNavigate } from 'react-router-dom';

// material
import { styled } from '@mui/material/styles';
import {
  Box, Button, Typography, Container,
  Avatar,
  Card,
  IconButton,
  ListItem,
  ListItemText,
  List,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Stack,
  Tab,
  TextField
} from '@mui/material';

import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';


// components
import Page from '../components/Page';

import { parseValidationErrorMessage } from "../utils/Utilities";


import AlertDialog from "../components/AlertDialog";
import { DeviceOrderdButtons } from "../components/_dashboard/soundbox";
import { useAuth } from "../components/customContextProviders/AuthContext";
import { GetOrganizationDetailsById, SetupOrganizationConfig } from "../network/Organization";

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));





export default function SoundBoxControlCenter() {

  const navigate = useNavigate();
  const { organzationClientId, sessionUserData, audioCubeAppLevelSettings } = useAuth()


  const [selectedDeviceTab, setSelectedDeviceTab] = useState('1');
  const [isUpdatedDeviceModal, setIsUpdatedDeviceModal] = useState(false);


  const [listDense, setListDense] = useState(false);
  const [listSecondary, setListSecondary] = useState(false);

  const [value, setValue] = React.useState('1');

  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [alertDialogMetas, setAlertDialogMetas] = useState({
    message: "",
    title: "",
    btnLabel: "",

  });

  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  const [noOfTriggersPerDay, setNoOfTriggersPerDay] = useState("");
  const [offlineCheckDays, setOfflineCheckDays] = useState("");

  const handleNoOfTriggersValChange = (event, _newValue) => {
    setNoOfTriggersPerDay(event.target.value);
  };
  const handleOfflineCheckDays = (event, _newValue) => {
    setOfflineCheckDays(event.target.value);
  };


  const handleDeviceTabChange = (_event, newValue) => {
    setSelectedDeviceTab(newValue);
  };



  useEffect(() => {
    getOrganizationDetails(sessionUserData?.user?.organization?.id)
    return () => {
    }

  }, []);



  function onUpdateDeviceModalAction(d) {
    alert(d)
  }




  function setDevicePingJobs(organizationId, noOfTriggersPerDay, alertOfflineDays) {
    SetupOrganizationConfig(organizationId, alertOfflineDays, noOfTriggersPerDay).then((_res) => {
      setAlertDialogMetas({ ...alertDialogMetas, message: "Updated Successfully !", title: "Updated", btnLabel: "OK" });
      setOpenAlertDialog(true)
    }).catch((err) => {
      setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(err), title: "", btnLabel: "OK" });
      setOpenAlertDialog(true)
    })



  }




  function getOrganizationDetails(organizationId) {

    GetOrganizationDetailsById(organizationId).then((res) => {
      setNoOfTriggersPerDay(res?.data?.data?.allow_number_of_trigger_in_day)
      setOfflineCheckDays(res?.data?.data?.offline_check_duration)

    }).catch((_err) => {

    })
  }







  return (
    <Page title="Devices">
      <Container maxWidth="false">
        <Box >
        <DeviceOrderdButtons/>

        </Box>



        <Box sx={{ width: '100%', typography: 'body1',mt:2 }}>
          <Card sx={{ width: "100%" }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} aria-label="lab API tabs example">
                  <Tab label="Devices" value="1" />
                  <Tab label="Profile" value="2" />

                </TabList>
              </Box>
              <TabPanel value="1">

                <Stack direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ p: 3 }}
                >
                  <Typography sx={{ fontSize: 16, fontWeight: 'bold' }}>
                    Alert if device is online for
                  </Typography>


                  {
                    audioCubeAppLevelSettings?.offlineCheck !== null && audioCubeAppLevelSettings?.offlineCheck !== undefined &&
                      Object.keys(audioCubeAppLevelSettings?.offlineCheck).length !== 0 ?
                      <FormControl size="small" sx={{ minWidth: 150 }}>
                        <InputLabel id="frequency-filter-select-label">Offline Check </InputLabel>
                        <Select
                          labelId="frequency-filter-select-label"
                          id="frequency-filter-select"
                          label="Frequency "
                          value={offlineCheckDays}
                          onChange={handleOfflineCheckDays}>
                          {
                            Object.entries(audioCubeAppLevelSettings?.offlineCheck)?.map(([key, value]) => (
                              <MenuItem key={key} value={key} sx={{ p: 1.5 }}>{value}</MenuItem>
                            ))
                          }
                        </Select>
                      </FormControl>
                      :
                      null
                  }
                </Stack>

                {/* <Stack direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ p: 3 }}
                >
                  <Typography sx={{ fontSize: 16, fontWeight: 'bold' }}>
                    No of triggers per day
                  </Typography>

                  {
                    audioCubeAppLevelSettings?.triggerOfDay !== null && audioCubeAppLevelSettings?.triggerOfDay !== undefined &&
                      Object.keys(audioCubeAppLevelSettings?.triggerOfDay).length !== 0 ?

                      <FormControl size="small" sx={{ minWidth: 150 }}>
                        <InputLabel id="frequency-filter-select-label">Triggers </InputLabel>
                        <Select
                          labelId="frequency-filter-select-label"
                          id="frequency-filter-select"
                          label="Frequency "
                          value={noOfTriggersPerDay}
                          onChange={handleNoOfTriggersValChange}
                        >
                          {
                            Object.entries(audioCubeAppLevelSettings?.triggerOfDay)?.map(([key, value]) => (
                              <MenuItem value={key} sx={{ p: 1.5 }}>{value}</MenuItem>
                            ))
                          }

                        </Select>
                      </FormControl>
                      :
                      null
                  }
                </Stack> */}

                <Box sx={{ width: '100%', p: 3, textAlign: 'center' }}>
                  <Button variant="outlined" color="secondary" size="large" sx={{ minWidth: '20vw' }} onClick={() => setDevicePingJobs(sessionUserData?.user?.organization?.id, noOfTriggersPerDay, offlineCheckDays)}>SAVE</Button>
                </Box>


              </TabPanel>
              <TabPanel value="2" sx={{ p: 0, }}>
                <List dense={listDense} sx={{ p: 0 }}>

                  <ListItem
                    sx={{ p: 3, backgroundColor: 'rgba(176, 185, 199, .1)' }}
                    secondaryAction={
                      <Stack
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        spacing={2}
                      >
                        <IconButton edge="end" aria-label="delete">
                          <Avatar />
                        </IconButton>
                        <IconButton edge="end" aria-label="delete">
                          <EditOutlinedIcon />
                        </IconButton>
                        <IconButton edge="end" aria-label="delete">
                          <DeleteOutlineOutlinedIcon />
                        </IconButton>
                      </Stack>

                    }
                  >

                    <ListItemText
                      sx={{ color: '#535353' }}
                      primary="Profile Picture"
                      listSecondary={listSecondary ? 'Secondary text' : null}
                    />
                  </ListItem>

                  <ListItem
                    sx={{ p: 3, backgroundColor: 'white' }}
                    secondaryAction={
                      <TextField size="small" variant="outlined" label="Name" />
                    }
                  >

                    <ListItemText
                      primary="User Name"
                      listSecondary={listSecondary ? 'Secondary text' : null}
                    />
                  </ListItem>

                  <ListItem
                    sx={{ p: 3 }}
                    secondaryAction={
                      <TextField size="small" variant="outlined" label="User Id" />
                    }
                  >

                    <ListItemText
                      primary="User Id"
                      listSecondary={listSecondary ? 'Secondary text' : null}
                    />
                  </ListItem>

                  <ListItem
                    sx={{ p: 3, backgroundColor: 'white' }}
                    secondaryAction={
                      <TextField size="small" variant="outlined" label="Mobile" />
                    }
                  >

                    <ListItemText
                      primary="Mobile"
                      listSecondary={listSecondary ? 'Secondary text' : null}
                    />
                  </ListItem>

                  <ListItem
                    sx={{ p: 3 }}
                    secondaryAction={
                      <TextField size="small" variant="outlined" label="Email " />
                    }
                  >

                    <ListItemText
                      primary="Email"
                      listSecondary={listSecondary ? 'Secondary text' : null}
                    />
                  </ListItem>

                  <ListItem
                    sx={{ p: 3, backgroundColor: 'white' }}
                    secondaryAction={
                      <TextField size="small" variant="outlined" label="Password"

                      />
                    }
                  >

                    <ListItemText
                      primary="Password "
                      listSecondary={listSecondary ? 'Secondary text' : null}
                    />
                  </ListItem>

                </List>

                <Box sx={{ width: '100%', p: 3, textAlign: 'center' }}>
                  <Button variant="outlined" color="secondary" size="large" sx={{ minWidth: '20vw' }}>SAVE</Button>
                </Box>

              </TabPanel>

            </TabContext>
          </Card>
        </Box>



        <AlertDialog openAlertDialog={openAlertDialog} message={alertDialogMetas?.message} title={alertDialogMetas?.title}
          btnLabel={alertDialogMetas?.btnLabel} handleClose={() => setOpenAlertDialog(false)} />


      </Container>
    </Page>
  );
}
